module.exports = __webpack_public_path__ + "43aeaf3219a62fd8283845582c625dce.png";